import React, { useState, useEffect } from 'react';
import {useAuth} from "../../auth/AuthProvider";
import { Spinner } from 'react-bootstrap';
import {getMachineConnectionStatus} from "../../../lib/api/getMachineConnectionStatus";

export const MachineConnectionStatus = ({uniqueId, classes}) => {
    const [color, setColor] = useState('red');
    const [loading, setLoading] = useState(true);

    const {token} = useAuth();

    const [useClasses, setUseClasses] = useState("d-flex flex-column align-items-center align-middle")

    useEffect(() => {
        if (classes != undefined && classes != "") {
            setUseClasses(classes);
        }

    }, [classes]);

    useEffect(() => {
        getMachineConnectionStatus(token, uniqueId).then(data => {
            setLoading(false);
            // console.log(data);
            if (data) {
                const connected = data["connected"];
                // console.log("connected", connected);
                if (connected !== undefined) {
                    if (connected === null) {
                        setColor('gray');
                    }
                    else if (connected === true) {
                        setColor('green');
                    }
                    else {
                        setColor('red');
                    }
                }


                // setColor('green');
            }
        })

    }, [token, uniqueId])

    return (
        <div className={useClasses}>
            <div
                style={{
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    backgroundColor: loading ? 'transparent' : color,
                    border: '1px solid #ccc',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {loading && <Spinner animation="border" size="sm" />}
            </div>
        </div>
    );
};